<template>
  <component :is="item.value instanceof Object ? 'div' : 'span'" class="row-wrapper">
    <template v-if="item.value instanceof Object && item.value.template">
      <div :class="item.class" :style="item.styles">
        <component v-if="item.label && item.label.template" :is="item.label" :item="item.item"></component>
        <div v-else :class="`custom-label ${item.labelClass}`" :style="labelStyles"><span :style="item.labelItemStyles" :class="labelItemClass">{{ item.key }}</span><span v-if="item.showColon" class="custom-colon">:</span></div>
        <div :class="`custom-value ${item.valueClass}`" :style="item.valueStyles"><component :is="item.value" :item="item.item"></component></div>
      </div>
    </template>
    <template v-else>
      <div :class="item.class" :style="item.styles">
        <div :class="`custom-label ${item.labelClass}`" :style="labelStyles">
          <h6 v-if="item.title">{{ item.key }}</h6>
          <h5 v-else-if="item.subtitle">{{ item.key }}</h5>
          <span :style="{fontWeight: item.boldFontWeight || 600, ...item.labelItemStyles}" v-else>{{ item.key }}</span>
          <span v-if="item.showColon" class="custom-colon">:</span>
        </div>
        <div v-if="item.value" :class="`custom-value ${item.valueClass}`">
          <div :style="item.valueStyles">{{ item.value }}</div>
        </div>
      </div>
    </template>
  </component>
</template>

<script>
export default {
  props: {
    item: Object
  },
  data() {
    return {
      labelStyles: {
        display: 'flex',
        justifyContent: 'space-between',
        fontWeight: this.item.boldFontWeight || 600,
        ...this.item.labelStyles,
      },
      labelItemStyles: {
        fontWeight: this.item.boldFontWeight || 600,
        ...this.item.labelItemStyles,
      },
      labelItemClass:
        'label-item ' +
        this.item.labelItemClass,
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .custom-colon {
    // display: none;
  }
  @media (max-width: 677px) {
    .row {
      .custom-value.text-end {
        text-align: left !important;
      }
    }
  }
  @media (min-width: 768px) {
    .custom-colon {
      display: inline;
    }
  }

  .label-item::after {
    content: var(--date);
    color: red;
  }
}
</style>